import debug from 'debug';

export default {
    selection: {
        created: debug('canvas:event:selection:created'),
        cleared: debug('canvas:event:selection:cleared'),
        updated: debug('canvas:event:selection:updated')
    },
    objects: {
        modified: debug('canvas:event:objects:modified')
    },
    canvas: {
        created: debug('canvas:event:created'),
        rerendered: debug('canvas:event:rerendered'),
        boundingBox: {
            moveY: debug('canvas:event:boundingbox:move:y'),
            moveX: debug('canvas:event:boundingbox:move:x')
        },
        object: {
            added: debug('canvas:event:object:added')
        }
    }
};